import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppUtils } from "../../../app-utils";
import { AppConfigService } from "../../../../config/app-config.service";
import { AppConfig } from "../../../../config/app-config";
import { RichSearchList } from "../../../../search/search-list/rich-search-list";
import { SearchPageInterface } from "../../../../search/search-list/results/pagination/search-page-interface";
import { Filter } from "../../../../search/search-list/filters/filter-block/filter-item/filter";
import { TranslateService } from "../../../translate.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HtmlUtilsService } from "../../../../html-utils/html-utils.service";
import { FacetService } from "../../facets/facet.service";
import { QueryParams } from "../../query-params.model";
import { ListService } from "../../list.service";

@Component({
  selector: "app-pagination-list",
  templateUrl: "./pagination-list.component.html",
  styleUrls: ["./pagination-list.component.scss"],
})
export class PaginationListComponent implements OnInit {
  @Input() showLeft: boolean = true;

  @Input() searchResult: RichSearchList;

  @Input() facets: Filter[];

  @Input() showMoreOnMobile = false;

  @Input() showMoreLoadingIndicator = false;

  @Input() showPageSize = true;

  @Output() loadMoreFromPageEmitter = new EventEmitter<QueryParams>();

  appConfig: AppConfig = new AppConfig();

  constructor(
    public translateService: TranslateService,
    private router: Router,
    private appConfigService: AppConfigService,
    private route: ActivatedRoute,
    private facetService: FacetService,
    public htmlUtils: HtmlUtilsService,
    private listService: ListService
  ) {}

  ngOnInit() {}

  onPageChange(page: string) {
    if (+page >= this.searchResult.totalPages) {
      this.searchResult.pageNumber = this.searchResult.totalPages;
      this.goToPage(this.searchResult.totalPages);
    } else if (+page < 1) {
      this.searchResult.pageNumber = 1;
      this.goToPage(this.searchResult.pageNumber);
    } else {
      this.goToPage(+page);
    }
  }

  onPageSizeChange() {
    this.goToPage(1);
  }

  hasNext() {
    return this.searchResult.totalPages >= this.searchResult.pageNumber + 1;
  }

  hasPrev() {
    return this.searchResult.pageNumber - 1 >= 1;
  }

  goToNext() {
    this.goToPage(this.searchResult.pageNumber + 1);
  }

  goToPrev() {
    this.goToPage(this.searchResult.pageNumber - 1);
  }

  loadMore() {
    this.loadMoreFromPageEmitter.emit(
      this.createPageParams(this.searchResult.pageNumber)
    );
  }

  private goToPage(page: number) {
    let currentPage = AppUtils.getCurrentPage();

    let queryParams = this.createPageParams(page);
    queryParams.url = HtmlUtilsService.getSearchUrl(currentPage);
    this.listService.addEvent(queryParams);
  }

  private createPageParams(page: number): QueryParams {
    let queryParams = new QueryParams({});

    queryParams.phrase = this.searchResult.phrase;
    queryParams.page = page;
    queryParams.pageSize = this.searchResult.pageSize;
    queryParams.filters = this.facetService.filtersToString();

    let sort = this.route.snapshot.queryParams.sort;

    if (sort) {
      queryParams.sort = sort;
    }

    if (this.searchResult.sortField) {
      queryParams.sort = this.searchResult.sortField;
    }

    if (this.route.snapshot.queryParamMap.get("searchInText")) {
      queryParams.searchInText =
        this.route.snapshot.queryParamMap.get("searchInText") == "true";
    }
    return queryParams;
  }
}
